import React, { useState } from "react";
import { Form } from "antd";
import { Icon } from "@iconify/react";
import TextArea from "antd/es/input/TextArea";
import toast from "@comps/toast";
import { getErrorProps, makeRequest } from "@utils/helpers";
import { ButtonComponent, CancelButton, ModalComponent } from "@comps/components";
import { rejectCaseReq } from "../requests";

const formName = "rejectForm";

/**
 * Rejecting a treatment plan, with the reason the technician will act on.
 *
 * Wears the same shell as every other confirmation in the app (see
 * BaseConfirm) — an icon chip in the tone of the action, a title that
 * asks the question, and a commit button that repeats the verb. It is a
 * dialog rather than a plain confirm because this one needs a reason,
 * and the reason is what the other side reads.
 */
const RejectCaseComponent = (props) => {
  const [errors, setErrors] = useState([]);
  const [loader, setLoader] = useState(false);

  const rules = {
    reject_reason: [{ required: true, message: "Say why the plan is being rejected" }],
  };

  const onFinish = (data) => {
    makeRequest(setLoader, rejectCaseReq, {
      id: props.caseid,
      reject_reason: data.reject_reason,
    }, onSuccess, onError);
  };

  const onSuccess = () => props.onSuccess();

  const onError = (data, res) => {
    setErrors(Array.isArray(data) ? { reject_reason: data } : []);
    toast.error((res && res.msg) || "Unable to reject this plan");
  };

  const footer = (
    <div className="form-actions">
      <CancelButton key="close_button" onClick={ () => props.handleCancel(false) } text="Go back" />
      <ButtonComponent
        key="create_button"
        form={ formName }
        htmlType="submit"
        type="primary"
        danger
        state={ loader }
      >
        Reject plan
      </ButtonComponent>
    </div>
  );

  return (
    <ModalComponent
      className="base-modal confirm-modal confirm-modal--danger"
      icon="tabler:x"
      mainTitle="Reject this treatment plan?"
      subTitle="The technician reworks the plan from your reason"
      open={ true }
      onCancel={ props.handleCancel }
      width="min(560px, calc(100vw - 32px))"
      footer={ footer }
    >
      <Form layout="vertical" name={ formName } onFinish={ onFinish }>
        <Form.Item
          name="reject_reason"
          rules={ rules.reject_reason }
          label="Why is it being rejected?"
          className="da-mb-16"
          onChange={ () => setErrors([]) }
          { ...getErrorProps(errors['reject_reason']) }
        >
          <TextArea rows={ 4 } placeholder="e.g. Upper arch spacing does not match the prescription" />
        </Form.Item>
      </Form>

      <p className="confirm-outcome">
        <Icon icon="tabler:arrow-narrow-right" width={ 17 } />
        <span>The case goes back to the technician with your reason attached.</span>
      </p>
    </ModalComponent>
  );
};

export default RejectCaseComponent;
